import { Link } from 'react-router-dom';
import { Anchor, Heading, Page, PageContent, Paragraph } from 'grommet';

export default function NotFound() {
  return (
    <Page kind="narrow" pad="medium">
      <PageContent>
        <Heading level={1} size="small">Page not found</Heading>
        <Paragraph fill>
          That page doesn't exist. Head back to the{' '}
          <Anchor as={Link} to="/">scoreboard</Anchor> or browse the{' '}
          <Anchor as={Link} to="/docs">league docs</Anchor>.
        </Paragraph>
      </PageContent>
    </Page>
  );
}
